module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "summary-layout"
  }, [_c('table', {
    staticClass: "table table-fixed"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.filteredData), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.check_loc))]), _c('td', [_vm._v(_vm._s(data.check_time))]), _c('td', [_vm._v(_vm._s(data.check_otherpctime))]), _c('td', [_vm._v(_vm._s(data.check_diffms))]), _c('td', [_vm._v(_vm._s(data.check_status))])])
  }), 0)])])]), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('QueryFilter', {
    attrs: {
      "showReportButton": _vm.showReportButton,
      "showDate": _vm.showDate,
      "showStartDate": _vm.showStartDate
    },
    on: {
      "filter": _vm.filter,
      "report": _vm.downloadReport
    }
  })], 1), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("地點")]), _c('th', [_vm._v("主機時間")]), _c('th', [_vm._v("獨立主機時間")]), _c('th', [_vm._v("偏差毫秒(<200)")]), _c('th', [_vm._v("狀態")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a94ea188","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ReportExport/OtherPcLogSummary.vue
// module id = 1534
// module chunks = 1